export const CompanyLocationMapping = {
    SET_COMPANYLOCATIONMAPPING: "SET_COMPANYLOCATIONMAPPING",
    GET_NOTMAPPEDLOCATION: "GET_NOTMAPPEDLOCATION",
}